import { defineStore } from 'pinia';
import { ref } from 'vue';
import { isAnonymousMode, setAnonymousMode } from '@/utils/anonymousMode';

export const useAnonymousStore = defineStore('anonymous', () => {
  const enabled = ref(isAnonymousMode());

  const setEnabled = (value, { reload = true } = {}) => {
    enabled.value = Boolean(value);
    setAnonymousMode(enabled.value, { reload });
  };

  const toggle = () => {
    setEnabled(!enabled.value, { reload: true });
  };

  return { enabled, setEnabled, toggle };
});
